import React from 'react'
import { withContentRect } from 'react-measure'
import { transition } from '../../constants'

/* global window */

const AnimatedCenterOrLeftContent = withContentRect('bounds')(
  class extends React.PureComponent {
    constructor() {
      super()
      this.state = {
        starting: true,
      }
    }
    render() {
      const {
        measureRef,
        contentRect,
        center,
        children,
        container,
        animate,
      } = this.props
      const content = contentRect.bounds
      const ready = content.width && container.width
      if (this.props.starting && ready && typeof window !== 'undefined') {
        window.requestAnimationFrame(() => {
          this.props.setStarting(false)
        })
      }
      return (
        <div
          className="content"
          style={{
            ...(() => {
              if (ready && center) {
                const tx = (container.width - content.width) / 2
                return {
                  transform: `translateX(${tx}px)`,
                }
              } else if (center) {
                return {}
              }
              return {}
            })(),
            display: 'inline-block',
            transition:
              this.state.starting || !animate ? undefined : transition,
          }}
          ref={measureRef}
        >
          {children}
        </div>
      )
    }
  },
)

const AnimatedCenterOrLeftContainer = withContentRect('bounds')(
  class extends React.PureComponent {
    constructor() {
      super()
      this.state = {
        starting: true,
      }
    }
    render() {
      const { measureRef, contentRect, center, children, animate } = this.props
      const { starting } = this.state
      return (
        <div
          ref={measureRef}
          style={{
            position: 'relative',
            textAlign: center && starting ? 'center' : 'left',
          }}
          className="container"
        >
          <AnimatedCenterOrLeftContent
            center={center}
            container={contentRect.bounds}
            starting={starting}
            setStarting={val => this.setState({ starting: val })}
            animate={animate}
          >
            {children}
          </AnimatedCenterOrLeftContent>
        </div>
      )
    }
  },
)

export default class AnimatedCenterOrLeft extends React.Component {
  render() {
    const { animate = true, center = false } = this.props
    return animate ? (
      <AnimatedCenterOrLeftContainer center={center} animate={animate}>
        {this.props.children}
      </AnimatedCenterOrLeftContainer>
    ) : (
      <div style={{ textAlign: center ? 'center' : 'left' }}>
        <div style={{ display: 'inline-block' }}>{this.props.children}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./components/visual/AnimatedCenterOrLeft.js